/**
 * Module dependencies.
 */

import React from 'react';
import { reduce } from 'lodash';
import BigNumber from 'bignumber.js';
import { Field } from 'app/components/organisms/field/field';

/**
 * Export `LinkedStatusTransaction` component.
 */

export function LinkedStatusTransaction(props: any): JSX.Element {
  const linkedTransactions = props.form.cache.hooks?.linked?.data ?? [];
  const [amount, linked] = props.form.getValues(['amount', 'linked']);
  const linkedItems = linkedTransactions.filter((item: any) => {
    return (linked ?? []).includes(item.id);
  });

  const total = reduce(
    linkedItems,
    (acc: any, item: any) => {
      return new BigNumber(acc).plus(item.amount).toString();
    },
    '0'
  );

  const result = new BigNumber(total).plus(amount);

  return (
    <div className={'mb-2 mt-8 rounded-lg border border-border p-4'}>
      <Field title={'Amount'} value={amount} />

      <Field title={'LinkedTransactions'} value={total} />

      <Field danger={result.isGreaterThan(0)} last title={'Total'} value={result.toString()} />

      {result.isGreaterThan(0) && (
        <div className={'mt-2 text-red-500'}>{'The value overflow the sell transaction'}</div>
      )}
    </div>
  );
}
